/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';

/**
 * 
 * @export
 * @interface SiteOperationsMapZoneResponseDto
 */
export interface SiteOperationsMapZoneResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    siteId: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    longitude: number | null;
    /**
     * 
     * @type {Array<PerimeterPointDto>}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    perimeter: Array<PerimeterPointDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    isMain: boolean;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    totalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    healthyAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    warningAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    criticalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapZoneResponseDto
     */
    totalOpenIncidents: number;
}

/**
 * Check if a given object implements the SiteOperationsMapZoneResponseDto interface.
 */
export function instanceOfSiteOperationsMapZoneResponseDto(value: object): value is SiteOperationsMapZoneResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('siteId' in value) || value['siteId'] === undefined) return false;
    if (!('siteName' in value) || value['siteName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('perimeter' in value) || value['perimeter'] === undefined) return false;
    if (!('isMain' in value) || value['isMain'] === undefined) return false;
    if (!('totalAssets' in value) || value['totalAssets'] === undefined) return false;
    if (!('healthyAssets' in value) || value['healthyAssets'] === undefined) return false;
    if (!('warningAssets' in value) || value['warningAssets'] === undefined) return false;
    if (!('criticalAssets' in value) || value['criticalAssets'] === undefined) return false;
    if (!('totalOpenIncidents' in value) || value['totalOpenIncidents'] === undefined) return false;
    return true;
}

export function SiteOperationsMapZoneResponseDtoFromJSON(json: any): SiteOperationsMapZoneResponseDto {
    return SiteOperationsMapZoneResponseDtoFromJSONTyped(json, false);
}

export function SiteOperationsMapZoneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteOperationsMapZoneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'siteId': json['siteId'],
        'siteName': json['siteName'],
        'name': json['name'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'perimeter': (json['perimeter'] == null ? null : (json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
        'isMain': json['isMain'],
        'totalAssets': json['totalAssets'],
        'healthyAssets': json['healthyAssets'],
        'warningAssets': json['warningAssets'],
        'criticalAssets': json['criticalAssets'],
        'totalOpenIncidents': json['totalOpenIncidents'],
    };
}

export function SiteOperationsMapZoneResponseDtoToJSON(json: any): SiteOperationsMapZoneResponseDto {
    return SiteOperationsMapZoneResponseDtoToJSONTyped(json, false);
}

export function SiteOperationsMapZoneResponseDtoToJSONTyped(value?: SiteOperationsMapZoneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'siteId': value['siteId'],
        'siteName': value['siteName'],
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'perimeter': (value['perimeter'] == null ? null : (value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
        'isMain': value['isMain'],
        'totalAssets': value['totalAssets'],
        'healthyAssets': value['healthyAssets'],
        'warningAssets': value['warningAssets'],
        'criticalAssets': value['criticalAssets'],
        'totalOpenIncidents': value['totalOpenIncidents'],
    };
}

